import { IContact } from '@nkr/models/index';
import * as React from 'react';

export interface IMicrositeSearchContext {
    coachList: IContact[],
    onCoachChange?: (recipientId: number, coachContactId: number) => void
}

export const MicrositeSearchContext = React.createContext<IMicrositeSearchContext | null>(null);
export const MicrositeSearchProvider = MicrositeSearchContext.Provider;